<template>
  <el-table-column :prop="col.prop"
                   :label="col.label"
                   :width="col.width + 'px'"
                   :sortable="col.sortable ? col.sortable: false"
                   :show-overflow-tooltip="true"
  >
    <template v-if="col.children">
      <m-column v-for="(item, index) in col.children"
                :key="index"
                :col="item">
      </m-column>
    </template>
    <template slot-scope="scope"
    >
      <div class="auto-input" v-if="!col.readOnly">
        <el-input v-model="scope.row[col.prop]"></el-input>
      </div>
      <div class="span"
           ref="text"
           :style="{color: col.fieldColor}"
           @contextmenu.prevent="copyText(scope.row[col.prop])"
      >
        {{scope.row[col.prop]}}
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'MColumn',
  props: {
    col: {
      type: Object,
    },
  },
  data() {
    return {
      id: this.col.uid,
      text: '',
      menudata: {
        // 菜单box的样式   Menu box style
        boxStyle: 'width:150px;background:#f55;z-index:2000',
        // 菜单选项的样式 Style of menu options
        optionStyle: 'color:#fff;line-height:30px;font-size:15px;',
        menus: [
          {
            content: '复制',
            id: 'copy',
            callback: 'copy',
            style: 'border-bottom:1px solid #fff;background:#333;line-height:30px;',
            iconStyle: 'width:20px;height:20px;',
            iconPosition: 'left',
          },
        ],
      },
    };
  },
  methods: {
    copyFuntion() {
      const input = document.createElement('input');// 在这里创建一个input标签
      input.setAttribute('type', 'text');
      input.value = this.text;
      input.setAttribute('value', this.text);
      document.body.appendChild(input);
      input.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      document.body.removeChild(input);
    },
    copyText(text) {
      this.text = text;
      this.copyFuntion();
    },
  },
};
</script>
